import React from "react";
import { Collapse, Panel } from "../../../components";
import Tooltip from "rc-tooltip";
import { FaLock, FaRegQuestionCircle } from "react-icons/fa";
import styled from "styled-components";
import { STYLES } from "../../../constants";
import S from "../Styles";

function FilterSection({
  title,
  tooltipText,
  children,
  active,
  disabled,
  nested,
  filterInfo
}) {
  return (
    <SSection nested={nested}>
      <Collapse defaultActiveKey={active}>
        <Panel
          key={1}
          header={
            <S.FilterTitle
              className="d-flex align-items-center w-100"
              nested={nested}
            >
              {title}{" "}
              {tooltipText && (
                <Tooltip overlay={tooltipText} placement="top">
                  <FaRegQuestionCircle className="ml-2" />
                </Tooltip>
              )}
              {disabled && <FaLock className="ml-2 lock" />}
              {!disabled && filterInfo}
            </S.FilterTitle>
          }
        >
          {children}
        </Panel>
      </Collapse>
    </SSection>
  );
}

const SSection = styled("section")`
  .rc-collapse-content > .rc-collapse-content-box {
    margin-top: 0;
  }
  @media (max-width: ${STYLES.screen.sm}) {
    ${({ nested }) =>
      nested
        ? `
          &:first-child {
            margin-top: -15px
          }
          `
        : `
          border-top: 1px solid ${STYLES.color.grey};
          padding-left: 15px;
          padding-right: 15px;
    
          &:nth-last-child(2) {
            border-bottom: 1px solid ${STYLES.color.grey};
          }
    
          .rc-collapse-header b {
            font-size: 18px;
          }
        `}
  }
`;

export default FilterSection;
